import { Component, Input } from '@angular/core'
import { signDictator } from '@app/features/generator/signDictator'

@Component({
    selector: 'contract-mexico-v5',
    templateUrl: 'mexico.component.html',
    styleUrls: ['../../../../app.component.scss']
})
export class ContractMexico {
    @Input() public name = ''
    @Input() public date
    @Input() public customer
    @Input() public metrocert
    @Input() public signOperator = ''

    signDictator = signDictator

    constructor() {}
}

@Component({
    selector: 'contract-canada-v5',
    templateUrl: 'canada.component.html',
    styleUrls: ['../../../../app.component.scss']
})
export class ContractCanada {
    @Input() public name = ''
    @Input() public date
    @Input() public customer
    @Input() public metrocert
    @Input() public signOperator = ''

    signDictator = signDictator

    constructor() {}
}

@Component({
    selector: 'contract-europe-v5',
    templateUrl: 'europe.component.html',
    styleUrls: ['../../../../app.component.scss']
})
export class ContractEurope {
    @Input() public name = ''
    @Input() public date
    @Input() public customer
    @Input() public metrocert
    @Input() public signOperator = ''

    signDictator = signDictator

    constructor() {}
}

@Component({
    selector: 'contract-usa-v5',
    templateUrl: 'usa.component.html',
    styleUrls: ['../../../../app.component.scss']
})
export class ContractUSA {
    @Input() public name = ''
    @Input() public date
    @Input() public customer
    @Input() public metrocert
    @Input() public signOperator = ''

    signDictator = signDictator

    constructor() {}
}